import PartnerDetails from 'components/shared/PartnerDetails'
import SliceManager from 'components/shared/SliceManager'
import delve from 'dlv'
import React from 'react'
import PreviewBanner from 'src/components/shared/PreviewBanner'

import {
  getDataDependencies,
  buildStaticPaths,
} from 'services/api'

import fetchContentType from 'src/lib/Strapi/fetchContentType'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

const Partner = ({ pageData, preview }) => {
  const hero = delve(pageData, 'hero')
  const slices = delve(pageData, 'slices')
  const details = {
    intro: delve(pageData, 'intro'),
    services: delve(pageData, 'services.data', []),
    techStacks: delve(pageData, 'techStacks.data', []),
    location: delve(pageData, 'location', {}),
    logo: delve(pageData, 'logo'),
  }
  const [embedFormSlice] = slices.filter(slice => slice.__component === 'slices.embed-form');
  const otherSlices = slices.filter(slice => slice.__component !== 'slices.embed-form');

  return (
    <>
      {preview && <PreviewBanner />}
      <div className="container">
        {details && <PartnerDetails {...details} embedForm={embedFormSlice} />}
        {slices && <SliceManager slices={otherSlices} />}
      </div>
    </>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('partners')
  return buildStaticPaths(data, 'partners')
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'partners',
    `filters[slug]=${params.slug}${
      preview ? '&publicationState=preview' : ''
    }`
  )
  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  const pageData = await getDataDependencies(delve(data, '0'))

  return {
    props: {
      pageData,
      preview,
    },
  }
}

export default Partner
